import { createReducer } from 'redux-starter-kit';
import { SET_FUNDS_AND_MPS_REF } from './actions';
const INITIAL_STATE = {
  fundsAndMpsRef: {}
};

export default createReducer(INITIAL_STATE, {
  [SET_FUNDS_AND_MPS_REF]: (state, { payload }) => {
    state.fundsAndMpsRef = payload;
  }
});
